import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { CustomThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import Login from './auth/LogIn';
import Home from './pages/Home';
import Orders from './pages/Orders';
import Couriers from './pages/Couriers';
import Restaurants from './pages/Restaurants';
import PricingPlans from './pages/PricingPlans';
import Finance from './pages/Finance';
import CompanyProfile from './pages/CompanyProfile';
import Reports from './pages/Reports';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <CustomThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/home" element={<Home />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/couriers" element={<Couriers />} />
              <Route path="/restaurants" element={<Restaurants />} />
              <Route path="/pricing-plans" element={<PricingPlans />} />
              <Route path="/finance" element={<Finance />} />
              <Route path="/company" element={<CompanyProfile />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="*" element={<Navigate to="/home" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </CustomThemeProvider>
    </LanguageProvider>
  );
}

export default App;
